import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";

import TextBlock from "./TextBlock";
import FeaturesBlock from "./FeaturesBlock";

class HomeBlocks extends Component {

    getBlocks = () => {
        return this.props.blocks.map((block, key) => {
            switch (block.type) {
                case 'text': {
                    return <TextBlock block={block} key={key}/>
                }
                case 'features': {
                    return <FeaturesBlock block={block} key={key}/>
                }
                default: {
                    return '';
                }
            }
        })
    };

    render() {

        return (
            <div className={this.props.className}>
                {this.getBlocks()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        blocks: state.getIn(['home', 'blocks']),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(HomeBlocks)`
`));